/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    creds: {
      domain: null, // 'netsapiens.meet.netsapiens.com',
      // token = 'email=alighterink@crexendo.com&password=Oct@2018'  https://${domain}/enterprise_api/authenticate
      // token: '06b465ca-d305-4dba-a118-1ecd6eaf8c3f',
      hostId: null, // '4294039',
      // curl -d 'auth_token=b7698a5d-8d8c-4043-8ff3-c90443c4bed5&host_id=4294039'  https://${domain}/enterprise_api/host/fetch
      login_token_public_key: null, // '0d025f0c3253ae7bb634bb4ca551cef97a795a7ef06bad45e5c06bf0fed93bcc',
    },
    iotumVisible: false,
    iotumRendering: false,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setUserPortalStatus: (state, action) => {
      if (state.user) {
        state.user.portal_status = action.payload;
      }
    },
    setVideoCreds: (state, action) => {
      state.creds = action.payload;
    },
    setIotumVisible: (state, action) => {
      state.iotumVisible = action.payload;
    },
    setIotumRendering: (state, action) => {
      state.iotumRendering = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setUser, setUserPortalStatus, setVideoCreds, setIotumVisible, setIotumRendering,
} = userSlice.actions;

// Selectors
export const selectUser = (state) => state.user.user;
export const selectUserLanguage = (state) => state.user.user?.language;
export const selectUserTimeZone = (state) => state.user.user?.timeZone;
export const selectSMS = (state) => state.user.user?.sms;
export const selectVideoCreds = (state) => state.user.creds;
export const selectIotumVisible = (state) => state.user.iotumVisible;
export const selectIotumRendering = (state) => state.user.ioutmRendering;

export default userSlice.reducer;
